import { H3, P, TypeWrapper } from '@ahmdigital/ui';

type Props = {
  amount: number;
};

const CalculatorResults = ({ amount }: Props): JSX.Element => {
  const children =
    amount === 0 ? (
      <H3>Good news, looks like you might not have to pay the MLS!</H3>
    ) : (
      <>
        <H3>You might have to pay about ${amount.toFixed(2)} extra in tax</H3>
        <P looksLike="h3" variant="regular">
          without hospital cover for a full tax year.
        </P>
      </>
    );

  return <TypeWrapper variant="center">{children}</TypeWrapper>;
};

export default CalculatorResults;
